<template>
  <b-modal
      v-model="cropModalOpen"
      title="Crop Image"
      size="md"
      header-bg-variant="white"
      header-text-variant="dark"
      body-class="p-0"
      footer-class="px-3 py-2"
      centered
      no-close-on-backdrop
      hide-header-close
      class="crop-modal"
  >
    <!-- Modal Header with custom title -->
    <template v-slot:modal-header>
      <h5 class="modal-title">
        Crop Image
        <span class="muted font-size-13 d-block font-weight-normal">Adjust the cropping area to create a square image</span>
      </h5>
      <b-button
          variant="link"
          class="close text-black font-weight-bold"
          aria-label="Close"
          @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </b-button>
    </template>

    <!-- Modal Content with cropper -->
    <div class="crop-container">
      <vue-cropper
          :key="cropperKey"
          ref="cropper"
          :src="cropImg"
          alt="Source Image"
          :aspect-ratio="1"
          :zoom-on-wheel="false"
          :zoom-on-touch="false"
          drag-mode="move"
          :moveable="false"
          :auto-crop-area="1"
          @ready="onCropperReady"
      >
      </vue-cropper>
    </div>

    <!-- Modal Footer -->
    <template v-slot:modal-footer>
      <div class="text-left font-size-14 font-weight-bold mb-0" style="flex:1">Zoom</div>
      <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="w-100">
          <b-form-input
              v-model.number="zoomValue"
              type="range"
              :min="1"
              :max="2"
              :step="0.001"
              class="flex-grow-1"
              @input="updateOverlaySettings"
          ></b-form-input>
        </div>
      </div>
      <div>
        <b-button variant="outline-primary" class="mr-2" @click="closeModal">
          <i class="fas fa-times mr-1"></i> Cancel
        </b-button>
        <b-button variant="primary" @click="applyCrop">
          <i class="fas fa-check mr-1"></i> Crop Image
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import VueCropper from 'vue-cropperjs';

import { BModal, BButton } from 'bootstrap-vue';
import {mapMutations, mapState} from "vuex";

export default {
  name: 'CropModal',
  components: {
    BModal,
    BButton,
    VueCropper
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    initialAspectRatio: {
      type: Number,
      default: NaN // Free form by default
    }
  },
  data() {
    return {
      localVisible: false,
      currentAspectRatio: this.initialAspectRatio,
      cropData: null,
      zoomValue: 0,
      cropImg:this.image,
      cropperOptions: {
        dragMode: 'move',
        viewMode: 1,
        autoCropArea: 0.9,
        responsive: true,
        zoomOnWheel: false,
        movable: false
      }
    };
  },
  computed: {
    cropperKey() {
      // When zoomValue is zero, append a suffix so the key is different.
      return this.zoomValue === 0 ? this.cropImg + '-reset' : this.cropImg;
    },
    ...mapState('imageEditor',[
      'cropModalOpen'
    ]),
  },
  watch: {
    /* visible(newVal) {
      this.localVisible = newVal;
    },
    localVisible(newVal){
      if(!newVal){
        this.$emit('closeModal');
      }
    } */
  },
  methods: {
    ...mapMutations('imageEditor', ['SET_IMAGE_PREVIEW','UPDATE_CROP_MODAL_VISIBILITY']),
    updateZoom(e){

    },
    onCropperReady(e) {
      // console.log(this.cropImg);
      // this.$refs.cropper.setMoveable(false);
    },
    updateOverlaySettings(){
      const cropper = this.$refs.cropper;
      cropper.zoomTo(this.zoomValue);
    },
    updateCropData() {
      if (!this.cropper) return;
      const data = this.cropper.getData(true); // get rounded values
      this.cropData = {
        x: data.x,
        y: data.y,
        width: data.width,
        height: data.height
      };
    },

    zoomIn() {
      if (!this.cropper) return;
      this.cropper.zoom(0.1);
    },

    zoomOut() {
      if (!this.cropper) return;
      this.cropper.zoom(-0.1);
    },
    resetCropper() {
      if (!this.cropper) return;
      this.cropper.reset();
    },

    applyCrop() {
      this.SET_IMAGE_PREVIEW(this.$refs.cropper.getCroppedCanvas().toDataURL())
      this.UPDATE_CROP_MODAL_VISIBILITY(false);
    },

    closeModal() {
      this.UPDATE_CROP_MODAL_VISIBILITY(false);
      this.onClose();
    }
  },

};
</script>

<style scoped>
.crop-container {
  display: flex;
  flex-direction: column;
}

.cropper-wrapper {
  height: 400px;
  background-color: #212529;
  overflow: hidden;
}

.aspect-ratio-controls {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.aspect-ratio-btn {
  min-width: 50px;
}

.helper-text {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.crop-dimensions {
  font-family: monospace;
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #dee2e6;
}
</style>

<!-- Global styles for Cropper.js and custom overrides -->
<style>
/* Cropper.js base styles */
.cropper-container {
  direction: ltr;
  font-size: 0;
  line-height: 0;
  position: relative;
  touch-action: none;
  user-select: none;
  max-width: 100%;
  background-color: #212529;
}

.cropper-container img {
  display: block;
  height: 100%;
  image-orientation: 0deg;
  max-height: none !important;
  max-width: none !important;
  min-height: 0 !important;
  min-width: 0 !important;
  width: 100%;
}

.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.cropper-wrap-box,
.cropper-canvas {
  overflow: hidden;
}

.cropper-drag-box {
  background-color: #fff;
  opacity: 0;
}

.cropper-modal {
  background-color: #000;
  opacity: 0.5;
}

.cropper-view-box {
  display: block;
  height: 100%;
  outline: 1px solid #007bff;
  outline-color: rgba(0, 123, 255, 0.75);
  overflow: hidden;
  width: 100%;
}

.cropper-dashed {
  border: 0 dashed #eee;
  display: block;
  opacity: 0.5;
  position: absolute;
}

.cropper-dashed.dashed-h {
  border-bottom-width: 1px;
  border-top-width: 1px;
  height: calc(100% / 3);
  left: 0;
  top: calc(100% / 3);
  width: 100%;
}

.cropper-dashed.dashed-v {
  border-left-width: 1px;
  border-right-width: 1px;
  height: 100%;
  left: calc(100% / 3);
  top: 0;
  width: calc(100% / 3);
}

.cropper-center {
  display: block;
  height: 0;
  left: 50%;
  opacity: 0.75;
  position: absolute;
  top: 50%;
  width: 0;
}

.cropper-center::before,
.cropper-center::after {
  background-color: #eee;
  content: ' ';
  display: block;
  position: absolute;
}

.cropper-center::before {
  height: 1px;
  left: -3px;
  top: 0;
  width: 7px;
}

.cropper-center::after {
  height: 7px;
  left: 0;
  top: -3px;
  width: 1px;
}

.cropper-face,
.cropper-line,
.cropper-point {
  display: block;
  height: 100%;
  opacity: 0.1;
  position: absolute;
  width: 100%;
}

.cropper-face {
  background-color: #fff;
  left: 0;
  top: 0;
}

.cropper-line {
  background-color: #007bff;
}

.cropper-line.line-e {
  cursor: ew-resize;
  right: -3px;
  top: 0;
  width: 5px;
}

.cropper-line.line-n {
  cursor: ns-resize;
  height: 5px;
  left: 0;
  top: -3px;
}

.cropper-line.line-w {
  cursor: ew-resize;
  left: -3px;
  top: 0;
  width: 5px;
}

.cropper-line.line-s {
  bottom: -3px;
  cursor: ns-resize;
  height: 5px;
  left: 0;
}

.cropper-point {
  background-color: #007bff;
  height: 8px;
  opacity: 0.75;
  width: 8px;
}

.cropper-point.point-e {
  cursor: ew-resize;
  margin-top: -3px;
  right: -3px;
  top: 50%;
}

.cropper-point.point-n {
  cursor: ns-resize;
  left: 50%;
  margin-left: -3px;
  top: -3px;
}

.cropper-point.point-w {
  cursor: ew-resize;
  left: -3px;
  margin-top: -3px;
  top: 50%;
}

.cropper-point.point-s {
  bottom: -3px;
  cursor: ns-resize;
  left: 50%;
  margin-left: -3px;
}

.cropper-point.point-ne {
  cursor: nesw-resize;
  right: -3px;
  top: -3px;
}

.cropper-point.point-nw {
  cursor: nwse-resize;
  left: -3px;
  top: -3px;
}

.cropper-point.point-sw {
  bottom: -3px;
  cursor: nesw-resize;
  left: -3px;
}

.cropper-point.point-se {
  bottom: -3px;
  cursor: nwse-resize;
  height: 10px;
  opacity: 1;
  right: -3px;
  width: 10px;
}

.cropper-point.point-se::before {
  background-color: #007bff;
  bottom: -50%;
  content: ' ';
  display: block;
  height: 200%;
  opacity: 0;
  position: absolute;
  right: -50%;
  width: 200%;
}

.cropper-invisible {
  opacity: 0;
}

.cropper-bg {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}

.cropper-hide {
  display: block;
  height: 0;
  position: absolute;
  width: 0;
}

.cropper-hidden {
  display: none !important;
}

.cropper-move {
  cursor: move;
}

.cropper-crop {
  cursor: crosshair;
}

.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}

/* Modal style overrides */
.crop-modal .modal-content {
  border-radius: 0.5rem;
  overflow: hidden;
}
</style>
